export const baseButtonStyles = {
  bgcolor: "#24582A",
  color: "#FFFAF1",
  textTransform: "none",
  fontFamily:
    '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
  minHeight: { xs: 52, sm: 56, md: 60 },
  width: "100%",
  maxWidth: "100%",
  justifyContent: "space-between",
  px: { xs: 1.5, sm: 2 },
  py: { xs: 1, sm: 1.25 },
  fontSize: { xs: 16, sm: 18, md: 20 },
  lineHeight: 1.2,
  display: "flex",
  alignItems: "center",
  borderRadius: 2,
  overflow: "hidden",
  textAlign: "left",
  whiteSpace: "nowrap",
  "& .MuiButton-startIcon, & .MuiButton-endIcon": {
    flexShrink: 0,
  },
  "&:hover": {
    bgcolor: "#17371A",
  },
};

export const buttonPrimaryStyles = {
  border: "1px solid #17371A",
  bgcolor: "#24582A",
  color: "#FFFAF1",
  textTransform: "none",
  fontFamily:
    '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
  borderRadius: 2,
  minHeight: { xs: 38, sm: 40, md: 42 },
  px: { xs: 1.75, sm: 2.25, md: 3 },
  py: { xs: 0.75, sm: 1, md: 1.25 },
  fontSize: { xs: 14, sm: 15, md: 16 },
  fontWeight: 600,
  lineHeight: 1.2,
  boxShadow: 2,
  whiteSpace: "nowrap",
  "&:hover": {
    bgcolor: "#17371A",
  },
};

export const buttonSecondaryStyles = {
  border: "1px solid #24582A",
  borderRadius: 2,
  textTransform: "none",
  fontFamily:
    '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
  fontSize: { xs: 14, sm: 15, md: 16 },
  minHeight: { xs: 38, sm: 40, md: 40 },
  px: { xs: 1.75, sm: 2.25, md: 3 },
  py: { xs: 0.75, sm: 1 },
  lineHeight: 1.2,
  color: "#24582A",
  bgcolor: "transparent",
  whiteSpace: "nowrap",
  "&:hover": {
    bgcolor: "#D4E9CF",
  },
};

export const baseMenu = {
  paper: {
    width: { xs: "min(92vw, 320px)", sm: 240 },
    mt: 1,
    boxShadow: 3,
    borderRadius: 1.5,
    maxHeight: { xs: 240, sm: 260 },
    overflowY: "auto",
    backgroundColor: "#FFFAF1",
    border: "1px solid #D4E9CF",
  },
  menuItem: {
    px: { xs: 1.25, sm: 1.5 },
    py: { xs: 0.875, sm: 1 },
    minHeight: { xs: 44, sm: 40 },
    display: "flex",
    alignItems: "center",
    cursor: "default",
  },
  checkbox: {
    p: 0.5,
    color: "#24582A",
    "&.Mui-checked": {
      color: "#17371A",
    },
  },
  typography: (isChecked) => ({
    fontFamily:
      '"Mulish", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
    fontSize: { xs: 14, sm: 15, md: 16 },
    ml: 1,
    color: isChecked ? "#24582A" : "#052812",
    fontWeight: isChecked ? 600 : 400,
    userSelect: "none",
    lineHeight: 1.25,
    wordBreak: "break-word",
  }),
};

export const sectionBox = {
  backgroundColor: "#D4E9CF",
  border: "4px solid #24582A",
  width: "100%",
  maxWidth: "100%",
  p: { xs: 1.25, sm: 1.5, md: 2 },
  position: "relative",
  overflow: "visible",
  boxSizing: "border-box",
};